const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class CallToArms extends Event {
    constructor(){
        super(
            Age.Age1,
            EventNames.CallToArms,
            "The two weakest civilizations lost 1 civil action. Then the weakest one loses another civil action. They draw 1 military card for each action lost.",
            {}
        )
    }
}

module.exports = CallToArms;